import { useRef } from 'react';

export const useTour = () => {
  const uploadFilesRef = useRef(null);
  const actionsWithRecordsRef = useRef(null);

  const steps = [
    {
      title: 'Страница геоданных',
      description:
        'Добро пожаловать в раздел «Геоданные» — здесь вы загружаете, храните и распространяете картографические данные для приложений в едином тактическом контуре. Благодаря технологии быстрой загрузки по чанкам карты работают стабильно даже при ограниченных ресурсах. Управление простое и интуитивно понятное.',
      target: null,
    },
    {
      title: 'Загрузка файлов',
      description:
        'Загрузите необходимые данные в формате kml — просто перетащите файлы или выберите их с устройства. ',
      target: () => uploadFilesRef.current,
    },
    {
      title: 'Действия с записями',
      description: 'Вы можете скачать или удалить любой файл одним кликом для поддержания актуальной базы.',
      target: actionsWithRecordsRef.current,
    },
    {
      title: 'Подраздел ТМС',
      description:
        'В разделе TMS осуществляется загрузка и подключение карт в формате MBTiles. Сервис оптимизирован для быстрой и стабильной работы даже на устройствах с ограниченными ресурсами. Простое подключение, быстрая загрузка, полный контроль.',
      target: null,
    },
    {
      title: 'Загрузка ТМС',
      description:
        'Добавьте новую карту на сервер для её дальнейшего использования в приложениях. Введите название карты, укажите тип файла и загрузите файл формата MBTiles. После успешной загрузки карта станет доступной для всех подключённых устройств.',
      target: () => uploadFilesRef.current,
    },
    {
      title: 'Таблица карт',
      description:
        'После успешной загрузки карта отобразится в списке. Как только кнопка «Скачать» станет активной — карта полностью готова к использованию.',
      target: null,
    },
  ];

  return {
    uploadFilesRef,
    actionsWithRecordsRef,
    steps,
  };
};
